module.exports = __webpack_public_path__ + "img/stock6.6a89fa03.png";